import { WelcomeState } from '../components/VisitDictationShared/WelcomeState'

export const VisitWelcomePage = () => {
    return <WelcomeState type='visit'/>
}
